<p-dialog
  [modal]="true"
  [(visible)]="showDrawer"
  [style]="{ top: '100px', width: '500px' }"
  [showHeader]="false"
  [position]="'top'"
  class="search-modal"
  [closable]="true"
  [dismissableMask]="true">
  <div>
    <div class="flex align-items-center">
      <img
        src="https://images.poshvine.com/icon/search-icon-black.svg"
        alt="search"
        class="icon p-1 ml-1" />
      <input
        [placeholder]="
          env.staticTextContents.headerComponent.searchBarPlaceholder
        "
        class="w-full p-2 border-none search-inp"
        id="search-inp"
        type="text"
        [(ngModel)]="searchInput"
        (input)="debouncedPopulateMerchantList($event)" />
      <button
        name="search-close-button"
        class="border-none bg-none cursor-pointer"
        (click)="handleClose()">
        <img
          src="https://images.poshvine.com/icon/close-icon-black.svg"
          alt="close"
          class="icon p-1" />
      </button>
    </div>
    <div class="flex flex-column">
      <ng-container *ngFor="let result of searchResults">
        <button
          *ngIf="result.attributes.offers?.data?.[0]?.id"
          (click)="
            navigateToDetailsPage(result.attributes.offers?.data?.[0]?.id || '')
          "
          name="search-offer-result-button"
          class="border-none w-full text-left py-3 px-2 bg-none cursor-pointer eachMerchant">
          {{ result.attributes.name }}
        </button>
      </ng-container>
    </div>
  </div>
</p-dialog>
